import { Component } from 'react'
import Favourites from 'components/Favourites'
import { arrayMoveImmutable } from 'array-move'
import { NavigationHOC, GroupContentHOC } from 'hocs'
import { connect } from 'react-redux'
import { UpdateFavouritesOrder } from './actions'
import { selectFavourites } from './selectors'
import { filterByCustomer, getCustomer } from '../../helpers/utils'

class FavouritesContainer extends Component {
  onSortEnd = ({ oldIndex, newIndex }) => {
    this.props.UpdateFavouritesOrder(
      arrayMoveImmutable(this.props.favourites, oldIndex, newIndex)
    )
  }

  generateProps = () => ({
    ...this.props,
    onSortEnd: this.onSortEnd,
    favourites: filterByCustomer(this.props.favourites, getCustomer())
  })

  render() {
    return <Favourites {...this.generateProps()} />
  }
}

const mapStateToProps = (state) => ({ favourites: selectFavourites(state) })

const mapDispatchToProps = (dispatch) => ({
  UpdateFavouritesOrder: (favourites) =>
    dispatch(UpdateFavouritesOrder(favourites))
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(
  GroupContentHOC(NavigationHOC(FavouritesContainer), {
    stateName: 'favourites'
  })
)
